import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Hospital = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="hospital icon"
    className={`shrink-0 h-${size} w-${size} ${className}`}
    viewBox="0 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 23H4C3.44772 23 3 23.4477 3 24V56C3 56.5523 3.44772 57 4 57H12V23ZM4 20C1.79086 20 0 21.7909 0 24V56C0 58.2091 1.79086 60 4 60H15V20H4Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M60 23H52V57H60C60.5523 57 61 56.5523 61 56V24C61 23.4477 60.5523 23 60 23ZM49 20V60H60C62.2091 60 64 58.2091 64 56V24C64 21.7909 62.2091 20 60 20H49Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M48 7H16C15.4477 7 15 7.44772 15 8V57H49V8C49 7.44772 48.5523 7 48 7ZM16 4C13.7909 4 12 5.79086 12 8V60H52V8C52 5.79086 50.2091 4 48 4H16Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      d="M6 28H9V31H6V28Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      d="M6 35H9V38H6V35Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      d="M18 35H21V38H18V35Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      d="M24 35H27V38H24V35Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      d="M43 35H46V38H43V35Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      d="M37 35H40V38H37V35Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      d="M30.5 35H33.5V38H30.5V35Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      d="M6 42H9V45H6V42Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      d="M18 42H21V45H18V42Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      d="M43 42H46V45H43V42Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      d="M55 28H58V31H55V28Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      d="M55 35H58V38H55V35Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      d="M55 42H58V45H55V42Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M32 32C25.9359 32 21 27.0657 21 21C21 14.9359 25.9359 10 32 10C38.0641 10 43 14.9359 43 21C43 27.0657 38.0641 32 32 32"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M32 13C27.5904 13 24 16.5904 24 21C24 25.4128 27.5904 29 32 29C36.4128 29 40 25.4128 40 21C40 16.5904 36.4128 13 32 13"
      className={`color-iconPrimary-disabled ${pathClass}`}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30.5 24.5C30.5 25.3295 31.1705 26 32 26C32.8295 26 33.5 25.3295 33.5 24.5V22.5H35.5C36.3295 22.5 37 21.8295 37 21C37 20.172 36.3295 19.5 35.5 19.5H33.5V17.5C33.5 16.672 32.8295 16 32 16C31.1705 16 30.5 16.672 30.5 17.5V19.5H28.5C27.6705 19.5 27 20.172 27 21C27 21.8295 27.6705 22.5 28.5 22.5H30.5V24.5Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M37 45H27V57H37V45ZM24 42V60H40V42H24Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      d="M30.5 42H33.5V60H30.5V42Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
  </svg>
)
